(function () {
  "use strict";

  if (window.__auGwp) return;
  window.__auGwp = true;

  var el = document.getElementById("au-gwp-config");
  if (!el) return;
  var config;
  try {
    config = JSON.parse(el.textContent);
  } catch (e) {
    return;
  }

  var ids = (config.giftVariantIds || []).map(String);
  var widgetId = String(config.widgetId || "");
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  var had = !!config.giftInCart;
  var armedAt = 0;
  var giftKeys = [];
  var lineKeys = [];
  var HAD_KEY = "au-gwp-had";
  var RELOAD_KEY = "au-gwp-reload";
  var tries = 0;
  var reloading = false;

  function remember(on) {
    try {
      if (on) window.sessionStorage.setItem(HAD_KEY, "1");
      else window.sessionStorage.removeItem(HAD_KEY);
    } catch (e) {}
  }

  function remembered() {
    try {
      return window.sessionStorage.getItem(HAD_KEY) === "1";
    } catch (e) {
      return false;
    }
  }
  var pending = false;
  var codesTried = "";
  var noteCode = "";

  function isGift(item) {
    if (!item) return false;
    if (ids.indexOf(String(item.variant_id)) > -1) return true;
    var p = item.properties || {};
    return widgetId !== "" && String(p._widget_id) === widgetId;
  }

  function country() {
    var m = document.cookie.match(/(?:^|;\s*)localization=([^;]*)/);
    return m ? m[1].toUpperCase() : "";
  }

  function aud(cart) {
    return !cart || !cart.currency || cart.currency === "AUD";
  }

  function isAu(cart) {
    var c = country();
    return !!config.au && (!c || c === "AU") && aud(cart);
  }

  function stale(cart) {
    if (reloading) return true;
    var backToAu = !config.au && country() === "AU" && aud(cart);
    if (!backToAu && (!config.au || isAu(cart))) return false;
    try {
      if (window.sessionStorage.getItem(RELOAD_KEY)) return false;
      window.sessionStorage.setItem(RELOAD_KEY, "1");
    } catch (e) {
      return false;
    }
    reloading = true;
    var url = new URL(location.href);
    var market = ["country", "currency"].filter(function (k) {
      return url.searchParams.has(k);
    });
    if (!market.length) {
      location.reload();
      return true;
    }
    market.forEach(function (k) {
      url.searchParams.delete(k);
    });
    location.replace(url.href);
    return true;
  }

  function cartOf(e) {
    var c = e && e.detail && e.detail.cart;
    if (c && c.cart) c = c.cart;
    return c && Array.isArray(c.items) ? c : null;
  }

  function toast(message, tone) {
    if (!message) return;
    var old = document.querySelector(".au-gwp-toast");
    if (old) old.remove();
    var t = document.createElement("div");
    t.className = "au-gwp-toast";
    if (tone) t.setAttribute("data-tone", tone);
    t.setAttribute("role", tone === "error" ? "alert" : "status");
    t.textContent = message;
    var close = document.createElement("button");
    close.type = "button";
    close.className = "au-gwp-toast__close";
    close.setAttribute("aria-label", "Close");
    close.innerHTML = '<span class="layout--close"></span>';
    t.appendChild(close);
    document.body.appendChild(t);
    var timer = setTimeout(hide, 4500);
    function hide() {
      clearTimeout(timer);
      t.setAttribute("data-leaving", "");
      timer = setTimeout(function () {
        t.remove();
      }, 500);
    }
    close.addEventListener("click", hide);
  }

  function confetti() {
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var box = document.createElement("div");
    box.className = "au-gwp-confetti";
    box.setAttribute("aria-hidden", "true");
    for (var i = 0; i < 36; i++) {
      var piece = document.createElement("i");
      piece.style.setProperty("--x", Math.round(Math.random() * 100) + "vw");
      piece.style.setProperty("--drift", Math.round(Math.random() * 160 - 80) + "px");
      piece.style.setProperty("--spin", Math.round(Math.random() * 720 - 360) + "deg");
      piece.style.setProperty("--delay", Math.round(Math.random() * 400) + "ms");
      box.appendChild(piece);
    }
    document.body.appendChild(box);
    setTimeout(function () {
      box.remove();
    }, 3200);
  }

  function removals(cart, au) {
    var updates = null;
    var lines = cart.items.filter(isGift);
    var keep = au && (lines.filter(function (item) {
      return widgetId !== "" && String((item.properties || {})._widget_id) === widgetId;
    })[0] || lines[0]);
    lines.forEach(function (item) {
      if (item === keep && !(item.quantity > 1)) return;
      updates = updates || {};
      updates[item.key] = item === keep ? 1 : 0;
    });
    return updates;
  }

  var again = false;
  function remove() {
    if (pending) {
      again = true;
      return;
    }
    if (tries >= 3) return;
    pending = true;
    fetch(root + "cart.js", { credentials: "same-origin" })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .catch(function () {
        return null;
      })
      .then(function (fresh) {
        if (!fresh || !Array.isArray(fresh.items)) {
          tries++;
          return false;
        }
        var au = isAu(fresh);
        var updates = removals(fresh, au);
        if (!updates) return true;
        tries++;
        return fetch(root + "cart/update.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates: updates }),
        }).then(
          function (r) {
            if (r.ok) {
              if (!au) {
                remember(false);
                toast(config.auOnly, "error");
              }
            }
            return r.ok || r.status === 422;
          },
          function () {
            return false;
          }
        );
      })
      .then(function (done) {
        pending = false;
        if (again || !done) {
          again = false;
          remove();
        }
      });
  }

  function note() {
    var el = document.querySelector("#rebuy-cart .au-gwp-code-note");
    if (!el) return false;
    if (noteCode) el.textContent = noteCode + " - " + config.noCodes;
    el.hidden = !noteCode;
    return true;
  }

  function dropCodes(cart) {
    var titles = (cart.cart_level_discount_applications || []).map(function (entry) {
      return entry.discount_application || entry;
    }).filter(function (entry) {
      return entry.type === "discount_code" && entry.total_allocated_amount > 0;
    }).map(function (entry) {
      return String(entry.title);
    });
    var order = titles.map(function (title) {
      return title.toUpperCase();
    });
    var list = order.join(",");
    if (!list) {
      codesTried = "";
      return;
    }
    if (list === codesTried) return;
    codesTried = list;
    var keep = (cart.discount_codes || []).filter(function (entry) {
      return order.indexOf(String(entry.code).toUpperCase()) === -1;
    }).map(function (entry) {
      return entry.code;
    });
    fetch(root + "cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ discount: keep.join(",") }),
    })
      .then(function (r) {
        if (!r.ok) return;
        noteCode = titles.join(", ");
        note();
        toast(noteCode + " - " + config.noCodes, "error");
      })
      .catch(function () {});
  }

  function shopperLine(target) {
    var id = target.slice(2);
    if (target.indexOf("v:") === 0) return ids.indexOf(id) === -1;
    if (target.indexOf("k:") === 0) return giftKeys.indexOf(id) === -1 && ids.indexOf(id.split(":")[0]) === -1;
    if (target.indexOf("l:") === 0) return giftKeys.indexOf(lineKeys[Number(id) - 1]) === -1;
    return true;
  }

  function celebrate() {
    fetch(root + "cart.js", { credentials: "same-origin" })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (fresh) {
        if (!fresh || !fresh.items.some(isGift)) return;
        confetti();
        toast(config.unlocked);
      })
      .catch(function () {});
  }

  function check(cart) {
    if (!cart) return;
    lineKeys = cart.items.map(function (item) {
      return item.key;
    });
    giftKeys = cart.items.filter(isGift).map(function (item) {
      return item.key;
    });
    if (stale(cart)) return;
    var au = isAu(cart);
    var updates = removals(cart, au);
    if (updates) remove();
    if (!au) return;
    var has = giftKeys.some(function (key) {
      return !updates || updates[key] !== 0;
    });
    remember(has);
    if (has && !config.allowOrderCode) dropCodes(cart);
    else {
      codesTried = "";
      noteCode = "";
      if (had && !has && !updates && belowThreshold(cart)) toast(config.belowThreshold, "error");
    }
    if (has && !had && armedAt && Date.now() - armedAt < 15000) {
      armedAt = 0;
      celebrate();
    }
    had = has;
  }

  function belowThreshold(cart) {
    var subtotal = cart.total_price;
    if (typeof cart.items_subtotal_price === "number") {
      subtotal = (cart.cart_level_discount_applications || []).reduce(function (sum, entry) {
        return sum - ((entry.discount_application || entry).total_allocated_amount || 0);
      }, cart.items_subtotal_price);
    }
    return config.threshold > 0 && cart.items.some(function (item) {
      return !isGift(item);
    }) && subtotal < config.threshold * 100;
  }

  function refetch() {
    fetch(root + "cart.js", { credentials: "same-origin" })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(check, function () {});
  }

  document.addEventListener("au:cart:write-settled", function (e) {
    var d = e && e.detail;
    if (d && d.ok && d.targets && d.targets.some(shopperLine)) armedAt = Date.now();
  });

  document.addEventListener("rebuy:cart.change", function (e) {
    var cart = cartOf(e);
    if (cart) check(cart);
    else refetch();
    setTimeout(note, 50);
  });

  document.addEventListener("rebuy:smartcart.show", function () {
    setTimeout(note, 50);
  });

  document.addEventListener("input", function (e) {
    if (!noteCode || !e.target || e.target.id !== "rebuy-cart__discount-input") return;
    noteCode = "";
    note();
  });

  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "visible") stale();
  });

  if (stale()) return;
  if (isAu()) {
    if (config.giftInCart) remember(true);
  } else if (config.giftInCart) {
    refetch();
  } else if (remembered()) {
    remember(false);
    toast(config.auOnly, "error");
  }

  window.addEventListener("pageshow", function (e) {
    if (!e || !e.persisted) return;
    reloading = false;
    had = remembered();
    stale();
  });
})();
